import { render } from "./Calendar.vue?vue&type=template&id=259f7c55&bindings={\"getdatestream\":\"options\",\"date\":\"props\",\"emptyDates\":\"options\",\"getMonth\":\"options\",\"getYear\":\"options\"}"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script